import api from "./api";

async function getCustomerByContactId(id) {
  try {
    const response = await api.get(
      `api/customers/bycontact/${id}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getCustomerByContactId
};
